/* Keep one complete Product entity when review apps hydrate after server render. */
(() => {
  let productData;
  let scheduled = false;
  const selector = 'script[type="application/ld+json"]';
  const read = script => {
    try {
      const data = JSON.parse(script.textContent);
      return data['@type'] === 'Product' ? { script, data } : null;
    } catch {
      return null;
    }
  };
  const reconcile = () => {
    scheduled = false;
    const products = [...document.querySelectorAll(selector)].map(read).filter(Boolean);
    if (!productData) {
      const source = products.find(({ script, data }) => script.hasAttribute('data-ozera-product-schema') && data.offers)
        || products.find(({ data }) => data.offers && data.url);
      if (!source) return;
      productData = source.data;
    }
    const matching = products.filter(({ data }) => data.name === productData.name);
    const reviews = matching.filter(({ script, data }) => script.classList.contains('jdgm-server-jld') || data.aggregateRating || data.review);
    if (!reviews.length) return;
    const target = reviews[reviews.length - 1];
    const combined = {
      ...productData,
      ...target.data,
      url: productData.url,
      description: productData.description,
      brand: productData.brand,
      offers: productData.offers
    };
    const json = JSON.stringify(combined).replace(/</g, '\\u003c');
    if (target.script.textContent !== json) target.script.textContent = json;
    for (const { script } of matching) {
      if (script !== target.script) script.remove();
    }
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(reconcile);
  };
  const initialize = () => {
    if (!document.body.classList.contains('ozera-ankle-pdp')) return;
    reconcile();
    new MutationObserver(records => {
      if (records.some(record =>
        record.target.nodeType === 1 && record.target.matches(selector)
        || [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector)))
      )) schedule();
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', schedule);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
